import { Button } from 'antd';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ArrowRightIcon } from '@components/common/Icons/ArrowRightIcon';
import { CalculatorSubmitButtonProps } from './types';

export const CalculatorBackButton: FC<CalculatorSubmitButtonProps> = ({
  onClick,
  textKey = 'common.prevPage',
  isSvg = true,
}) => (
  <Button
    onClick={onClick}
    shape={'round'}
    className={
      'font-satoshi-black border-main text-main hover:border-main! hover:text-main! m-0 flex h-auto! items-center border border-solid bg-white! px-12! py-[0.8rem]! text-base leading-none! shadow-none hover:bg-white!'
    }
  >
    {isSvg && <ArrowRightIcon className={'mr-[0.8rem] rotate-180'} />}
    <FormattedMessage id={textKey} />
  </Button>
);
